/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.input`
	flex: 1;
	border: none;
	outline: none;
	padding: 13px 0 13px;
	font-size: 10px;
	font-weight: 500;
	text-align: center;

	&[type="password"] {
		background: #dde1e8;
		color: #55698C;

		::placeholder {
		    color: #55698C;
		    opacity: 1;
		}

		:-ms-input-placeholder {
		    color: #55698C;
		}

		::-ms-input-placeholder {
		    color: #55698C;
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/auth-form/input.js